import React, { useState } from "react";

const IntroCard = ({ src = "", srcWebm = "", srcMp4 = "", poster = "", onClick = null, className = "", isVideo = false }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`rounded-t-[10px] sm:rounded-t-[15px] md:rounded-t-[20px] flex flex-col overflow-hidden h-[120px] sm:h-[150px] md:h-[180px] lg:h-[220px] xl:h-[240px] 2xl:h-[250px] cursor-pointer transition-all duration-500 hover:shadow-2xl hover:shadow-ag-green/20 group relative ${className}`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Video or Image with zoom effect */}
      {isVideo ? (
        <video
          crossOrigin='anonymous'
          autoPlay
          muted
          loop
          playsInline
          poster={poster}
          className={`w-full h-full object-cover transition-transform duration-500 ${
            isHovered ? "scale-110" : "scale-100"
          }`}
        >
          {srcWebm && <source src={srcWebm} type="video/webm" />}
          {srcMp4 && <source src={srcMp4} type="video/mp4" />}
          {src && <source src={src} type="video/mp4" />}
          Your browser does not support the video tag.
        </video>
      ) : (
        <img
          crossOrigin='anonymous'
          src={src}
          alt=""
          className={`w-full h-full object-cover transition-transform duration-500 ${
            isHovered ? "scale-110" : "scale-100"
          }`}
        />
      )}
      
      {/* Overlay gradient on hover */}
      <div className={`absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent transition-opacity duration-300 ${
        isHovered ? "opacity-100" : "opacity-0"
      }`} />
      
      {/* Glow border effect */}
      <div className={`absolute inset-0 rounded-t-[10px] sm:rounded-t-[15px] md:rounded-t-[20px] border-2 border-ag-green/0 transition-all duration-300 ${
        isHovered ? "border-ag-green/50 shadow-inner" : ""
      }`} />
    </div>
  );
};

export default IntroCard;
